import { generate } from '../excel'
import { ExcelSpec } from '../excel/types'
import { run } from './process-actions'

export const download = async <Row, Totals>(spec: ExcelSpec<Row, Totals>, processName: string) =>
    run(processName, async () => generate(spec))
